import * as React from "react";
import { useState } from "react";
import { MoneyDisplayHelper } from "../../../../../../../react-core/Helpers/MoneyDisplayHelper";
import { CheckboxEditor } from "../../../../../../../react-core/Html/CheckboxEditor";
import { Lightbox, LightboxType } from "../../../../../../../react-core/Html/Components/Lightbox";
import { JsonDateParser } from "../../../../../../../react-core/Utils/JsonDateParser";
import { CurrencyCode } from "../../../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";
import { CashPayment } from "../../../../../../../Wrap/Models/Models/PortfolioAnalysis/Payment/CashPayment";
import { Table } from "../../../../../../Shared/Table/Table";
import { AriaTooltip } from "../../../../../../Shared/Tooltip/AriaTooltip";
import { Typography } from "../../../../../../Shared/Typography/Typography";
import { regularDepositMethodArraysMap } from "../../../Common/Resource/Contents";
import { PaymentSourceMap } from "../Transactions/Resource/Contents";

interface IThreeDotsDropdownProps {
    clientRegularPayment: CashPayment[];
    onClose: VoidFunction;
    onSelect: (batchId: number) => void;
}

export const SelectRegularPaymentPop = (props: IThreeDotsDropdownProps) => {
    const selectClientRegular = props.clientRegularPayment;
    const [selectdBatchId, setSelectdBatchId] = useState<number>(null);
    const [selectCashPayment, setSelectCashPayment] = useState<CashPayment>(null);

    const tooltipConfig = () => {
        return [
            {
                title: "Account number",
                data: selectCashPayment?.BankAccountNumber || "N/A",
            },
            {
                title: "Sort code",
                data: selectCashPayment?.SortCode || "N/A",
            },
            {
                title: "Next payment data",
                data:
                    selectCashPayment?.NextDate == null
                        ? "N/A"
                        : JsonDateParser.getFormatDate(selectCashPayment?.NextDate, "dd/MM/yyyy"),
            },
            { title: "Payer type", data: PaymentSourceMap[selectCashPayment?.Source] || "N/A" },
        ];
    };

    return (
        <>
            {selectClientRegular.length > 1 && (
                <Lightbox
                    show={selectClientRegular.length > 1}
                    title={"Current client regular payment instructions"}
                    contentAfterTitle={null}
                    onClose={() => {
                        setSelectdBatchId(null);
                        props.onClose();
                    }}
                    type={LightboxType.Modal}
                    cssWrapper={"is-default-lightbox"}
                >
                    <>
                        <p>
                            Multiple existing current regular payments have been identified which are being paid by the
                            client.
                        </p>
                        <p>Which one would you like to edit?</p>
                        <br />
                        <Table
                            cssWrapper="table-subtle table-first-last-cell-padding-reset"
                            data={selectClientRegular}
                            col={[
                                {
                                    title: "Subaccount",
                                    tdCssWrapper: "cell-right",
                                    thCssWrapper: "cell-right",
                                    key: "AccountNumber",
                                },
                                {
                                    title: "Method",
                                    key: "Method",
                                    render: (data) => {
                                        return regularDepositMethodArraysMap[data];
                                    },
                                },
                                {
                                    title: "Instruction",
                                    key: "Instruction",
                                },
                                {
                                    title: "Amount",
                                    key: "Amount",
                                    render: (data, row: CashPayment) => {
                                        return (
                                            <AriaTooltip
                                                cssWrapper="is-underlined-text no-border-radius"
                                                buttonText={MoneyDisplayHelper.FromatMoneyDisplay(
                                                    data,
                                                    CurrencyCode.GBP
                                                )}
                                                onClick={() => {
                                                    setSelectCashPayment(row);
                                                }}
                                                onClose={() => setSelectCashPayment(null)}
                                            >
                                                <Typography
                                                    type="auto-width"
                                                    wrapCss="mt-10 mb-0"
                                                    config={tooltipConfig()}
                                                />
                                            </AriaTooltip>
                                        );
                                    },
                                },
                                {
                                    title: "Select payment",
                                    key: "",
                                    render: (data, row: CashPayment) => {
                                        return (
                                            <CheckboxEditor
                                                value={selectdBatchId == row.BatchId}
                                                onChange={(v) => {
                                                    if (v) {
                                                        setSelectdBatchId(row.BatchId);
                                                    } else {
                                                        setSelectdBatchId(null);
                                                    }
                                                }}
                                                label="select this regular payment"
                                                cssWrapper="square-checkbox mb-0 label-sr-only"
                                            />
                                        );
                                    },
                                },
                            ]}
                        />
                        <div className="row row-center">
                            <button
                                className="btn primary"
                                onClick={() => {
                                    props.onSelect(selectdBatchId);
                                    setSelectdBatchId(null);
                                    props.onClose();
                                }}
                                disabled={selectdBatchId == null}
                            >
                                Select payment
                            </button>
                        </div>
                    </>
                </Lightbox>
            )}
        </>
    );
};
